export const OPMIColorScheme = {
    "palettes": [
        {
            "id": "palette1",
            "ranges": ["#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7"]
        },
        {
            "id": "palette2",
            "ranges": ["#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341"]
        },
        {
            "id": "palette3",
            "ranges": ["#FFCD7F", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette4",
            "ranges": ["#00AAE7", "#FFCD7F", "#13269E", "#58B341", "#00AAE7", "#FFCD7F", "#13269E", "#58B341"]
        },
        {
            "id": "palette5",
            "ranges": ["#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7"]
        },
        {
            "id": "palette6",
            "ranges": ["#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341"]
        },
        {
            "id": "palette7",
            "ranges": ["#FFCD7F", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette8",
            "ranges": ["#00AAE7", "#FFCD7F", "#13269E", "#58B341", "#00AAE7", "#FFCD7F", "#13269E", "#58B341"]
        },
        {
            "id": "palette9",
            "ranges": ["#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7"]
        },
        {
            "id": "palette10",
            "ranges": ["#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341"]
        },
        {
            "id": "palette11",
            "ranges": ["#FFCD7F", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette12",
            "ranges": ["#00AAE7", "#FFCD7F", "#13269E", "#58B341", "#00AAE7", "#FFCD7F", "#13269E", "#58B341"]
        },
        {
            "id": "palette13",
            "ranges": ["#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7"]
        },
        {
            "id": "palette14",
            "ranges": ["#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341"]
        },
        {
            "id": "palette15",
            "ranges": ["#FFCD7F", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette16",
            "ranges": ["#00AAE7", "#FFCD7F", "#13269E", "#58B341", "#00AAE7", "#FFCD7F", "#13269E", "#58B341"]
        },
        {
            "id": "palette17",
            "ranges": ["#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7"]
        },
        {
            "id": "palette18",
            "ranges": ["#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341"]
        },
        {
            "id": "palette19",
            "ranges": ["#FFCD7F", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette21",
            "ranges": ['#ECF6FF', '#CCCCCC', '#FFBD59', '#FFD23F', '#000000']
        },
        {
            "id": "palette22",
            "ranges": ["#FF86BF", "#91EB6F", "#E6CA3A", "#00AAE7", "#FF588E"]
        },
        {
            "id": "palette23",
            "ranges": ["#91EB6F", "#E6CA3A", "#00AAE7", "#FF588E", "#FF86BF"]
        },
        {
            "id": "palette24",
            "ranges": ["#E6CA3A", "#00AAE7", "#FF588E", "#FF86BF", "#91EB6F"]
        },
        {
            "id": "palette25",
            "ranges": ["#00AAE7", "#FF588E", "#FF86BF", "#91EB6F", "#E6CA3A"]
        },
        {
            "id": "palette26",
            "ranges": ["#FF588E", "#FF86BF", "#91EB6F", "#E6CA3A", "#00AAE7"]
        },
        {
            "id": "palette27",
            "ranges": ["#FF86BF", "#91EB6F", "#E6CA3A", "#00AAE7", "#FF588E"]
        },
        {
            "id": "palette28",
            "ranges": ["#FFFFFF"]
        }
    ],
    "themes": [
        {
            "id": "colorTheme1",
            "name": "colorTheme1",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette22"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette22"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette1", "palette2", "palette3", "palette2", "palette3"]
                },
                {
                    "type": "line",
                    "ranges": ["palette17", "palette3", "palette5"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette8", "palette7", "palette9", "palette10"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette12"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette13", "palette14", "palette15", "palette16", "palette17"]
                },
                {
                    "type": "treemap",
                    "ranges": ["palette22", "palette23", "palette24", "palette25", "palette26", "palette27"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette7"]
                },
                {
                    "type": "advancedTable",
                    "ranges": ["palette21"]
                },
            ],
            "sidebar": {
                "ranges": ["palette28"]
            }
        },
        {
            "id": "colorTheme2",
            "name": "colorTheme2",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette22"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette5"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette8", "palette7", "palette4", "palette9", "palette12"]
                },
                {
                    "type": "line",
                    "ranges": ["palette10", "palette11", "palette13"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette9", "palette13", "palette9", "palette10"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette12"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette8", "palette9", "palette10", "palette11", "palette12",]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette13", "palette14", "palette15", "palette16", "palette17"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette7"]
                },
            ]
        },
        {
            "id": "colorTheme3",
            "name": "colorTheme3",
            "charts": [
                {
                    "type": "bar",
                    "ranges": ["palette16", "palette17"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette16"]
                },
                {
                    "type": "pie",
                    "ranges": ["palette22"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette11", "palette10"]
                },
                {
                    "type": "line",
                    "ranges": ["palette19", "palette10", "palette9", "palette12"]
                }
            ]
        },
        {
            "id": "colorTheme4",
            "name": "colorTheme4",
            "charts": [
                {
                    "type": "bar",
                    "ranges": ["palette1"]
                },
            ]
        }
    ]
}